import React from 'react'
import { Link } from 'react-router-dom'
import { URL } from '../constants'
import errorImage404 from '../assets/images/broken-img-2.png'
import styles from '../styles/error404.module.css'

const NotFound_404 = () => {
    return (

        <div className={`${styles.errorPage} ${styles.alignVerticalCenter} container`}>
            <div>
                <div className="text-center"><img className="w-50" src={errorImage404} alt="404" /></div>
                <div>
                    <h1>Oops! Something went wrong.<br/>The page you are looking for couldn't be found.</h1>
                    <p>It appears that the page you are looking for moved or no longer exists.
                    <br/>
                    You can return home or stick around if you like 404 pages.</p>
                    <Link to={URL.home} className="return text-uppercase">take me back home</Link>
                </div>
            </div>
        </div>
   
    )
}

export default NotFound_404
